<template>
  <div class="page-content operator-registration-performances">
    <div class="row">
      <div class="col-12">
        <AggregateView />
        <WeeklyBreakdownView />
        <OperatorPerformanceCallsTable />
        <ExcludeCallsFromRegPerformances v-if="isDirector" />
        <WeeklyRegistrationRateTargets />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { nextTick, onMounted, defineAsyncComponent, toRefs } from 'vue';
import { useRoute } from 'vue-router';

import util from '@/Utils/util';
import { useProfile } from '@/use/profile';

const AggregateView = defineAsyncComponent(() => import('./OperatorPerformances/AggregateView.vue') as any);
const WeeklyBreakdownView = defineAsyncComponent(() => import('./OperatorPerformances/WeeklyBreakdownView.vue') as any);
const OperatorPerformanceCallsTable = defineAsyncComponent(() => import('./OperatorPerformances/OperatorPerformanceCallsTable.vue') as any);
const ExcludeCallsFromRegPerformances = defineAsyncComponent(() => import('./OperatorPerformances/ExcludeCallsFromRegPerformances.vue') as any);
const WeeklyRegistrationRateTargets = defineAsyncComponent(() => import('./OperatorPerformances/WeeklyRegistrationRateTargets.vue') as any);
const { userRoles } = useProfile();
const { isDirector} = toRefs(userRoles);

onMounted(async () => {
  const route = useRoute();
  const { hash } = route;

  await nextTick();
  util.moveScrollComponent(hash);
});
</script>